<template>
    <section>
        <section class="info-container">
            <section class="info-item-wrap">
                <p class="info-title">基本信息</p>
                <a-row class="m-t-18">
                    <a-col :span="8">
                        <a-row class="info-item">
                            <a-col class="key">单位名称</a-col>
                            <a-col class="val">{{detailsInfo.companyName}}</a-col>
                        </a-row>
                    </a-col>
                    <a-col :span="8">
                        <a-row class="info-item">
                            <a-col class="key">结算类型</a-col>
                            <a-col class="val">{{detailsInfo.typeName}}</a-col>
                        </a-row>
                    </a-col>
                </a-row>
                <a-row>
                    <a-col :span="8">
                        <a-row class="info-item">
                            <a-col class="key">时间范围</a-col>
                            <a-col class="val">{{detailsInfo.payYear+'-'+detailsInfo.payMonth}}</a-col>
                        </a-row>
                    </a-col>
                    <a-col :span="8">
                        <a-row class="info-item">
                            <a-col class="key">发放人数</a-col>
                            <a-col class="val">{{detailsInfo.personnelCount}}</a-col>
                        </a-row>
                    </a-col>
                </a-row>
                <a-row>
                    <a-col :span="8">
                        <a-row class="info-item">
                            <a-col class="key">应发工资</a-col>
                            <a-col class="val">{{detailsInfo.payGrossAmount || 0}}元</a-col>
                        </a-row>
                    </a-col>
                     <a-col :span="8">
                        <a-row class="info-item">
                            <a-col class="key">发放时间</a-col>
                            <a-col class="val">{{detailsInfo.createTime}}</a-col>
                        </a-row>
                    </a-col>
                </a-row>
                <a-row>
                   
                    <a-col :span="8">
                        <a-row class="info-item">
                            <a-col class="key">结算状态</a-col>
                            <a-col class="val" :style="{color:(detailsInfo.uploadPhoto && detailsInfo.uploadPhoto.length) ? 'green' :'red'}">{{(detailsInfo.uploadPhoto && detailsInfo.uploadPhoto.length) ? '已支付' : '未支付'}}</a-col>
                        </a-row>
                    </a-col>
                </a-row>
                <a-row>
                    <a-col :span="8">
                        <a-row class="info-item">
                            <a-col class="key">支付凭证</a-col>
                            <a-col class="val upload-preview-wrap">
                                <a class="file-item m-r-10" v-for="(item,ind) in detailsInfo.uploadPhoto" :key="ind">
                                    <preview-image :data="item.codeUrl" :size="100" />
                                </a>
                            </a-col>
                        </a-row>
                    </a-col>
                </a-row>
            </section>
             <section class="info-item-wrap">
                <p class="info-title">发放明细</p>
                <section class="list-table-container m-t-18">
                    <a-table size="small" :columns="columns" :data-source="listTableData" :pagination="{total,hideOnSinglePage:true}">
                        <template v-for="col in ['hotdayMoney', 'overtimeMoney', 'taxMoney','reduceMoney','againMoney']" :slot="col" slot-scope="text,list">
                            <div :key="col">
                                <a-input @blur="e => changeItem(e.target.value,col,list)" style="width:100px" :value="text"></a-input>
                            </div>
                        </template>
                    </a-table>
                </section>
             </section>
        </section>
    </section>
</template>

<script>
const columns = [
    {title:'序号',dataIndex:'key',align:'center',key:'key'},
    {title:'月份',dataIndex:'payMonth',align:'center',key:'payMonth'},
    {title:'姓名',dataIndex:'personnelName',align:'center',key:'personnelName'},
    {title:'身份证号',dataIndex:'idCard',align:'center',key:'idCard'},
    {title:'劳务班组',dataIndex:'teamName',align:'center',key:'teamName'},
    {title:'结算类型',dataIndex:'typeName',align:'center',key:'typeName'},
    {title:'天数',dataIndex:'workDay',align:'center',key:'workDay'},
    {title:'工时',dataIndex:'workTime',align:'center',key:'workTime'},
    {title:'结算单价(元)',dataIndex:'payPrice',align:'center',key:'payPrice'},
    {title:'高温补贴(元)',dataIndex:'hotdayMoney',align:'center',key:'hotdayMoney',scopedSlots: { customRender: 'hotdayMoney' }},
    {title:'加班补贴(元)',dataIndex:'overtimeMoney',align:'center',key:'overtimeMoney',scopedSlots: { customRender: 'overtimeMoney' }},
    {title:'扣税(元)',dataIndex:'taxMoney',align:'center',key:'taxMoney',scopedSlots: { customRender: 'taxMoney' }},
    {title:'减扣项(元)',dataIndex:'reduceMoney',align:'center',key:'reduceMoney',scopedSlots: { customRender: 'reduceMoney' }},
    {title:'补发项(元)',dataIndex:'againMoney',align:'center',key:'againMoney',scopedSlots: { customRender: 'againMoney' }},
    {title:'应发工资',dataIndex:'payGrossAmount',align:'center',key:'payGrossAmount'},
    // {title:'实发工资',dataIndex:'payNetAmount',align:'center',key:'payNetAmount'},
    {title:'开户行',dataIndex:'payBankname',align:'center',key:'payBankname'},
    {title:'银行卡号',dataIndex:'payCardnum',align:'center',key:'payCardnum'}
]
import previewImage from '@/components/previewImage'
export default {
    data(){
        return{
            columns,
            detailsInfo:{},
            total:0,
            listTableData:[]
        }
    },
    components:{previewImage},
    mounted(){
        this.sid && this.queryCompanyPaySalaryTotalDetails()
        this.sid && this.queryCompanyPaySalaryTotalPersonnelList()
    },
    computed:{
        sid(){
            return this.$route.query.id
        }
    },
    methods:{
        //公司发放详情
        queryCompanyPaySalaryTotalDetails(){
            this.$api.queryCompanyPaySalaryTotalDetails(this.sid).then(res =>{
                if(res.code === 200){
                    this.detailsInfo = res.data || {}
                    this.detailsInfo.uploadPhoto = this.detailsInfo.uploadPhoto ? JSON.parse(this.detailsInfo.uploadPhoto) : []
                }
            })
        },
        //工资发放详情-明细表
        queryCompanyPaySalaryTotalPersonnelList(){
            this.$api.queryCompanyPaySalaryTotalPersonnelList({companyPaySalaryTotalId:this.sid}).then(res =>{
                if(res.code === 200){
                    this.listTableData = (res.data && res.data.records) || []
                    this.listTableData.forEach((item,ind) =>{
                        item.key = ind +1
                    })
                    this.total = (res.data && res.data.total) || 0
                }
            })
        },
        //修改表格
        changeItem(val,name,list){
        
            if(isNaN(val)){
                val = 0
            }else{
                if(val.includes('.')){
                    val = val.substring(0,val.indexOf('.')+2)
                }
            }
            
            let newMap = [...this.listTableData]
            let payGrossAmount = list.payGrossAmount    //明细当前项的应发工资
            let totalPayGrossAmount = 0 //应发总工资
            newMap.forEach(item =>{
                if(item.id === list.id){
                    item[name] = val
                    payGrossAmount = this.calcPayAmount(item)
                    item.payGrossAmount = payGrossAmount
                    
                }
                totalPayGrossAmount += item.payGrossAmount
            })
            this.listTableData = newMap

            //提交
            let params = {}
            params['id'] = list.id
            params['payGrossAmount'] = payGrossAmount
            params[name] = val
            this.submit(params)
            this.updateCompanyPaySalaryTotal(totalPayGrossAmount)
            
        },
        //通过结算类型（小时工、日结算、月结算）计算应发工资
        calcPayAmount(obj){
            /*
                小时工=工时*结算单价+高温补贴+加班补贴+扣税-减扣项+补发项=应发工资
                日结算=天数*结算加单+高温补贴+加班补贴+扣税-减扣项+补发项=应发工资
                月结算=结算单价+高温补贴+加班补贴+扣税-减扣项+补发项=应发工资
            */
           let {payGrossAmount, //应发工资
                workTime,   //工时
                workDay,     //天数
                payPrice,   //结算单价
                hotdayMoney,    //高温补贴
                overtimeMoney,  //加班补贴
                taxMoney,   //扣税
                reduceMoney,    //减扣项
                againMoney  //补发项
                } = obj

           switch(obj.type){
                case "1": //小时工
                   payGrossAmount =  workTime * payPrice + parseFloat(hotdayMoney) + parseFloat(overtimeMoney) - parseFloat(taxMoney) - parseFloat(reduceMoney) + parseFloat(againMoney);
                   break;
                case "2" :  //日结算
                    payGrossAmount =  workDay * payPrice + parseFloat(hotdayMoney) + parseFloat(overtimeMoney) - parseFloat(taxMoney) - parseFloat(reduceMoney) + parseFloat(againMoney);
                    break;
                case "3":   //月结算
                    payGrossAmount =  parseFloat(payPrice) + parseFloat(hotdayMoney) + parseFloat(overtimeMoney) - parseFloat(taxMoney) - parseFloat(reduceMoney) + parseFloat(againMoney);
                    break;
           }

           return payGrossAmount

        },
        //配置工资发放-发放明细
        submit(params){
            this.$api.updateCompanyPaySalaryTotalPersonnel(params).then(res =>{
                if(res.code === 200){
                    this.queryCompanyPaySalaryTotalPersonnelList()
                }
            })
        },
        //修改工资发放-总的应发工资
        updateCompanyPaySalaryTotal(payGrossAmount){
            this.$api.updateCompanyPaySalaryTotal({id:this.sid,payGrossAmount}).then(res =>{
                if(res.code === 200){
                    this.queryCompanyPaySalaryTotalDetails()
                }
            })
        }
    }
}
</script>